import List from "@/components/list";
import vue from "@/main";

const Table = args => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};

  // 移除班级教学内容表信息
  function removeTeachingContent(item) {
    vue.$emit("removeTeachingContent", item);
  }
  // 编辑试题
  function setRequired(item, status) {
    vue.$emit("setRequired", item, status);
  }

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [
      ["icon-remove", "移除", () => removeTeachingContent(item), ""]
    ];
    // if (item.isRequired == 0) {
    //   dealConf.push([
    //     "icon-require",
    //     "设为必修",
    //     () => {
    //       setRequired(item, 1);
    //     }
    //   ]);
    // } else if (item.isRequired == 1) {
    //   dealConf.push([
    //     "icon-cancel-audit",
    //     "取消必修",
    //     () => {
    //       setRequired(item, 0);
    //     }
    //   ]);
    // }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "资源名称",
      prop: "name",
      minWidth: "300",
      showOverflowTooltip: true
    },
    {
      label: "类型",
      prop: "typeName",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "是否必修",
      prop: "isRequiredName",
      minWidth: "60",
      showOverflowTooltip: true
    },
    {
      label: "资源学时",
      prop: "videoCredit",
      minWidth: "60",
      showOverflowTooltip: true
    },
    {
      label: "有效期",
      prop: "expireDateStr",
      minWidth: "60",
      showOverflowTooltip: true
    },
    // {
    //   label: "状态",
    //   prop: "onlineStatusName",
    //   minWidth: "60",
    // },
    {
      label: "操作",
      fixed: "right",
      width: 80,
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
